import { Box } from "@mui/material";

export const ExternalPageLayout = ({
	children,
}: {
	children: React.ReactNode;
}) => {
	return (
		<Box
			sx={{
				width: "100%",
				height: "100%",
				display: "grid",
				placeContent: "center",
			}}
		>
			{children}
		</Box>
	);
};
